"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateNode = void 0;
var _uuid = require("uuid");
var _constant = require("./constant");
var generateNode = exports.generateNode = function generateNode(type) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '普通节点';
  var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '节点内容';
  var createUid = _constant.store.customCreateNodeId || _uuid.v4;
  switch (type) {
    case 'normal':
      return {
        id: createUid(),
        type: 'normal',
        title: title,
        content: content,
        configData: {},
        nodeList: [],
        color: 'red',
        nodeColor: '',
        ascending: 'true',
        descending: 'true'
      };
    case 'condition':
      return {
        id: createUid(),
        type: 'condition',
        title: '条件分支',
        color: '',
        nodeColor: '',
        ascending: 'true',
        descending: 'false',
        children: [{
          id: createUid(),
          title: '条件1',
          content: '条件1的内容',
          type: 'normal',
          configData: {},
          nodeList: [],
          color: '',
          nodeColor: '',
          ascending: 'true',
          descending: 'false'
        }, {
          id: createUid(),
          type: 'normal',
          title: '条件2',
          content: '条件2的内容',
          configData: {},
          nodeList: [],
          color: 'red',
          nodeColor: '',
          ascending: 'true',
          descending: 'false'
        }]
      };
    default:
      break;
  }
};